import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

export default function Account() {
  const { staff } = useAuth();
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);

  const changePassword = async (e) => {
    e.preventDefault();
    setMessage(null);
    if (newPass !== confirm) { setMessage({ error: true, text: 'New passwords do not match' }); return; }
    try {
      await api.put('/auth/password', { currentPassword: current, newPassword: newPass });
      setMessage({ error: false, text: 'Password updated' });
      setCurrent(''); setNewPass(''); setConfirm('');
    } catch (err) {
      setMessage({ error: true, text: err.response?.data?.error || 'Could not update password' });
    }
  };

  return (
    <div style={{ maxWidth: '420px' }}>
      <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '20px' }}>My account</h2>

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', padding: '20px', marginBottom: '16px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Account details</h3>
        <p style={{ fontSize: '14px', marginBottom: '4px' }}><span style={{ color: '#999' }}>Name: </span>{staff?.name}</p>
        <p style={{ fontSize: '14px', marginBottom: '4px' }}><span style={{ color: '#999' }}>Email: </span>{staff?.email}</p>
        <p style={{ fontSize: '14px' }}><span style={{ color: '#999' }}>Role: </span>{staff?.role}</p>
      </div>

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', padding: '20px', marginBottom: '16px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>Signing in</h3>
        <p style={{ fontSize: '13px', color: '#555', lineHeight: 1.5 }}>
          Sign in with your Google account ({staff?.email}). Password sign-in still works as a
          fallback during the switchover; Google accounts have no ClinicDesk password.
        </p>
      </div>

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', padding: '20px' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px' }}>Change password (fallback accounts only)</h3>
        {message && (
          <div style={{ background: message.error ? '#fff0f0' : '#f0fff4', border: `1px solid ${message.error ? '#ffcccc' : '#b6e2c5'}`, borderRadius: '8px', padding: '8px 12px', marginBottom: '12px', fontSize: '13px', color: message.error ? '#c00' : '#1a7f37' }}>
            {message.text}
          </div>
        )}
        <form onSubmit={changePassword}>
          {[['Current password', current, setCurrent], ['New password', newPass, setNewPass], ['Confirm new password', confirm, setConfirm]].map(([label, value, set]) => (
            <div key={label} style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '5px' }}>{label}</label>
              <input type="password" value={value} onChange={e => set(e.target.value)} required
                style={{ width: '100%', padding: '8px 11px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
          ))}
          <button type="submit"
            style={{ padding: '9px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>
            Update password
          </button>
        </form>
      </div>
    </div>
  );
}
